const Workspace = () =>
  import(
    /* webpackChunkName: "WorkspaceViews" */ '../views/workspace/Workspace.vue'
    );
const WorkspaceTabMyTickets = () =>
  import(
    /* webpackChunkName: "WorkspaceViews" */ '../views/workspace/WorkspaceTabMyTickets.vue'
    );
const WorkspaceTabAssignments = () =>
  import(
    /* webpackChunkName: "WorkspaceViews" */ '../views/workspace/WorkspaceTabAssignments.vue'
    );

export const routeWorkspace = [
  {
    path: 'workspace',
    name: 'Workspace',
    component: Workspace,
    redirect: 'workspace/tickets/mine',
    children: [
      {
        path: 'tickets/mine',
        name: 'MyTicketsTab',
        component: WorkspaceTabMyTickets,
        meta: {
          title: 'Workspace - My tickets'
        }
      },
      {
        path: 'assignments',
        name: 'AssignmentsTab',
        component: WorkspaceTabAssignments,
        meta: {
          title: 'Workspace - Assignments'
        }
      }
    ]
  }
];
